import {Fade, FadeTransition} from '@aboutyou/transitions';
import {COLORS, FONT_SIZES, FONT_WEIGHTS} from '@aboutyou/ui-components';
import React, {useEffect, useRef} from 'react';
import styled from 'styled-components';
import {MemoCouponBadgeActiveContent} from './CouponBadgeActiveContent';
import {MemoCouponBadgeActiveCountdown} from './CouponBadgeActiveCountdown';
import {useCouponBadgeActive} from './utils/useCouponBadgeActive';

export const CouponBadgeActive: React.FC<{
  productId: number;
  isInMiniADPDialog: boolean;
}> = ({productId, isInMiniADPDialog}) => {
  const {activatedCoupon, canShowBadge, canShowCountdown, headline} =
    useCouponBadgeActive({productId, isInMiniADPDialog});

  const disabled = useRef(false);
  useEffect(() => {
    disabled.current = Boolean(canShowBadge && canShowCountdown);
  }, [canShowBadge, canShowCountdown]);

  return (
    <Fade mounted={Boolean(canShowBadge)} duration={500}>
      <Wrapper data-testid="couponBadgeActive">
        <FadeTransition duration={500} disabled={disabled.current}>
          <Content>
            {canShowCountdown ? (
              <MemoCouponBadgeActiveCountdown
                activatedCoupon={activatedCoupon}
                headline={headline}
              />
            ) : (
              <MemoCouponBadgeActiveContent />
            )}
          </Content>
        </FadeTransition>
      </Wrapper>
    </Fade>
  );
};

const Wrapper = styled.div`
  border-radius: 4px;
  position: relative;

  color: ${COLORS.White};
  background-color: ${COLORS.PrimaryCoupon};
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  margin-bottom: 12px;

  ::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    bottom: -5px;
    left: clamp(0px, 17%, 50px);

    border-top: 6px solid;
    border-top-color: ${COLORS.PrimaryCoupon};
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;

  > span {
    display: flex;
    width: -webkit-fill-available;
  }
`;
